module.exports = __webpack_public_path__ + "img/img_mobile_occupation_quan.e1ad4b27.jpg";